<template>
    <div>
        <article class="single-project">

            <section class="page__toptext">
                <div class="topsection__text">
                    <h4 data-aos="zoom-in" data-aos-duration="2800">{{post.values.default_title}}</h4>
                    <h1 class="single-project-ingress" data-aos="zoom-in" data-aos-duration="2000">
                        {{post.values.default_ingress}}
                    </h1>
                </div>
                <div class="single-project-url">
                    <a :href="post.values.project_url" class="project__url" data-aos="zoom-in" data-aos-duration="2500">
                        {{post.values.url_name}}
                    </a>
                </div>
            </section>

            <div class="single-article-img clearfix">
                <img :src="post.values.default_featuredimage" :alt="post.values.default_title" class="single-project-img" />
            </div>

            <div class="single-project-desc-container">
                <div class="single-project-title">
                    <h1>Prosjekt oversikt</h1>
                </div>
                <div class="single-project-maintext">
                    <p>
                        {{post.values.default_maintext}}
                    </p>
                    <div class="project-key">
                        <div class="project-key_item" v-for="(item, index) in post.values.key" :key="index">
                            <span class="key__logo"><img :src="item.logo" v-if="item.logo" /></span>
                            <span class="key__text" v-if="item.text">{{item.text}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <section class="project-images-container">
                <div class="single-project-title">
                    <h1>Prosjekt oversikt</h1>
                </div>
                <div class="projects-images">
                    <img :src="post.values.full_screenshot" :alt="post.values.default_title" />
                </div>
            </section>

            <section class="projects-mobile-container">
                <div class="">
                    Mobil bilder i slider
                </div>
            </section>

        </article>

    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
});
</script>